import { Episodes, Seasons } from '@/shared/libs/sdk';

export function maxCollectionElementByParam(collection, param) {
  return [...collection].sort((a, b) => b[param] - a[param])[0];
}

export function minCollectionElementByParam(collection, param) {
  return [...collection].sort((a, b) => a[param] - b[param])[0];
}

export function maxCollectionParam(collection, param) {
  return maxCollectionElementByParam(collection, param)?.[param];
}

export function getAllSeasons(serialId) {
  return new Seasons({ id: serialId })
    .fetchAll()
    .then((seasons) => {
      return seasons.map((season) => ({
        ...season,
        serial: {
          id: serialId,
        },
      }));
    });
}

export function getEpisodes(season, serialId) {
  return new Episodes()
    .fetchAll('', {
      serialId,
      seasonId: season.id,
      reset: true,
    })
    .then((episodes) => {
      return episodes.map((episode) => {
        if (episode.season) {
          return episode;
        }
        return {
          ...episode,
          season,
        };
      });
    });
}

export async function getFirstEpisodeOfSerial(serialId) {
  const seasons = await getAllSeasons(serialId);

  for (let seasonIndex = 0; seasonIndex < seasons.length; seasonIndex++) {
    const episodes = await getEpisodes(seasons[seasonIndex], serialId);

    if (episodes.length) {
      return episodes[0];
    }
  }
}

export function findPreviousEpisode(episodes, episodeNumber) {
  const maxEpisodeNumber = episodeNumber != null
    ? episodeNumber
    : maxCollectionParam(episodes, 'episode') + 1;

  return maxCollectionElementByParam(
    episodes.filter(({ episode }) => episode < maxEpisodeNumber),
    'episode',
  );
}

export async function findPreviousEpisodeFromPreviousSeasons(serialId, seasonNumber) {
  const seasons = await getAllSeasons(serialId);
  const previousSeasons = seasons.filter(({ number }) => number < seasonNumber);

  for (let previousSeasonIndex = 0; previousSeasonIndex < previousSeasons.length; previousSeasonIndex++) {
    const season = previousSeasons[previousSeasonIndex];
    const episodes = await getEpisodes(season, serialId);

    if (episodes.length) {
      return findPreviousEpisode(episodes);
    }
  }
}

export function getPreviousEpisode(episodes, productEpisode, serialId, seasonNumber) {
  const previousEpisode = findPreviousEpisode(episodes, productEpisode);

  if (!previousEpisode) {
    return findPreviousEpisodeFromPreviousSeasons(serialId, seasonNumber);
  }

  return previousEpisode;
}

export function findNextEpisode(episodes, episodeNumber = 0) {
  return minCollectionElementByParam(
    episodes.filter(({ episode }) => episode > episodeNumber),
    'episode',
  );
}

export async function findNextEpisodeFromNextSeason(serialId, seasonNumber) {
  const seasons = await getAllSeasons(serialId);
  const nextSeasons = seasons.filter(({ number }) => number > seasonNumber).reverse();

  for (let nextSeasonIndex = 0; nextSeasonIndex < nextSeasons.length; nextSeasonIndex++) {
    const season = nextSeasons[nextSeasonIndex];
    const episodes = await getEpisodes(season, serialId);

    if (episodes.length) {
      return findNextEpisode(episodes);
    }
  }
}

export function getNextEpisode(episodes, productEpisode, serialId, seasonNumber) {
  const nextEpisode = findNextEpisode(episodes, productEpisode);

  if (!nextEpisode) {
    return findNextEpisodeFromNextSeason(serialId, seasonNumber);
  }

  return nextEpisode;
}
